import { LANGUAGES as LIB_LANGUAGES } from "../../phive-studio/config/languages.js";

export const LOCALES = [...LIB_LANGUAGES];
